import { RequiredContainer } from "./style"

export function Required() {
    return (
        <RequiredContainer>*</RequiredContainer>
    );
}